module.exports = __webpack_public_path__ + "img/hombreras.08d9c054.png";